import { render, staticRenderFns } from "./QualityTV.vue?vue&type=template&id=8b727b36&scoped=true"
import script from "./QualityTV.vue?vue&type=script&setup=true&lang=ts"
export * from "./QualityTV.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./QualityTV.vue?vue&type=style&index=0&id=8b727b36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b727b36",
  null
  
)

export default component.exports